import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container } from 'react-bootstrap';
import { auth } from '../services/firebase';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    // Set up auth state listener for changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, redirect to dashboard
        navigate('/dashboard', { replace: true });
      }
    });

    // If user is already logged in, redirect immediately
    if (auth.currentUser) {
      navigate('/dashboard', { replace: true });
    }

    // Clean up subscription
    return () => unsubscribe();
  }, [navigate]);

  // Only show this if we haven't redirected yet
  return (
    <Container className="mt-5">
      <h1>Welcome to Grizzly</h1>
      <p>Your one-stop solution for member management and flight tracking.</p>
      
      <div className="d-flex gap-2">
        <Button 
          variant="outline-primary"
          onClick={() => navigate('/about')}
        >
          About
        </Button>
        <Button 
          variant="primary"
          onClick={() => navigate('/login')}
        >
          Login
        </Button>
      </div>
    </Container>
  );
} 